import React, { useState } from 'react';
import AvatarDisplay from './AvatarDisplay';

const AvatarWithTooltip = ({ 
  ensName, 
  address, 
  size = 32,
  showFullENS = true,
  showAddress = true,
  children 
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const displayENS = ensName?.replace('.zpost.eth', '') || ensName;
  const shortAddress = address ? `${address.slice(0, 6)}...${address.slice(-4)}` : null;

  return (
    <div 
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children || (
        <AvatarDisplay
          ensName={ensName}
          address={address}
          size={size}
        />
      )}
      
      {showTooltip && (
        <div style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: '8px',
          padding: '0.75rem',
          background: 'var(--card-bg)',
          border: '1px solid var(--border)',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
          zIndex: 1000,
          minWidth: '180px',
          fontSize: '0.8rem',
          whiteSpace: 'nowrap'
        }}>
          {ensName && showFullENS && (
            <div style={{ 
              color: 'var(--gold)', 
              fontWeight: 'bold',
              marginBottom: '0.25rem'
            }}>
              {ensName}
            </div>
          )}
          
          {displayENS && showFullENS && (
            <div style={{ 
              color: 'var(--text-light)', 
              marginBottom: '0.25rem'
            }}>
              {displayENS}
            </div>
          )}
          
          {address && showAddress && (
            <div style={{ 
              color: 'var(--text-secondary)',
              fontSize: '0.75rem',
              wordBreak: 'break-all',
              whiteSpace: 'normal',
              maxWidth: '160px'
            }}>
              {shortAddress}
            </div>
          )}
          
          {/* Arrow */}
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid var(--card-bg)'
          }}></div>
        </div>
      )}
    </div>
  );
};

export default AvatarWithTooltip;
